import React, { useState } from "react";
import { Accordion, AccordionGroup } from "@origin-digital/ods-core";

export interface ICallbackEvent {
  isOpen: boolean;
}

export interface IAccordion {
  label: string;
  href?: string;
  child?: React.ReactNode;
}

export interface IAccordionsProps {
  accordions: IAccordion[];
  onAccordionOpen?: (accordian: IAccordion) => Promise<void> | void;
  open?: Record<string, boolean | undefined>;
}

export const Accordions = ({
  accordions,
  onAccordionOpen,
  //@ts-ignore
  open = {},
}: IAccordionsProps) => {
  const [openState, setOpenState] = useState<
    Record<string, boolean | undefined>
  >(open);

  const onToggle = (accordion: IAccordion) => {
    setOpenState({ [accordion.label]: !openState[accordion.label] });
    if (onAccordionOpen) {
      onAccordionOpen(accordion);
    }
  };

  return (
    <AccordionGroup>
      {accordions.map((acc, index) => {
        if (!acc || !acc.child) {
          return null;
        }
        return (
          <Accordion
            id={`accordion-group-${index}`}
            data-id={`accordion-group-${index}`}
            summary={acc.label}
            key={acc.label}
            onChange={() => onToggle(acc)}
            expanded={openState[acc.label] || false}
          >
            {acc.child && openState[acc.label] ? acc.child : <></>}
          </Accordion>
        );
      })}
    </AccordionGroup>
  );
};
